import React from 'react';

// Catches a failed lazy import so one broken chunk doesn't blank the page.
//
// Without this, React unmounts the whole tree when a lazy() import rejects and
// the visitor gets a white screen with no way back. That is not hypothetical:
// every deploy publishes new chunk filenames, so anyone holding an open tab
// from the previous release will 404 the moment they navigate to a route or
// open the map. Offering a reload is the fix for exactly that case, because
// reloading fetches the new index.html and its current chunk names.
export default class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // Left as a console warning rather than swallowed silently: this is the
    // signal that a chunk name went stale or a dependency failed to load.
    console.warn('Failed to load part of the page:', error?.message || error);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div className="chunk-error" role="alert">
        <p className="chunk-error__text">
          {this.props.message || "This part of the page didn't load."}
        </p>
        <button
          type="button"
          className="chunk-error__btn"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
      </div>
    );
  }
}
